import { useSelector } from 'react-redux';

const EMPTY = [];

/**
 * Returns whether a company feature flag is enabled (value strictly equals `true`).
 *
 * @param {string} featureName - The feature key to look up (see `companyFeaturesConstants`).
 * @returns {boolean} `true` if the feature's `value` is `true`, `false` if features are not yet loaded or the feature is disabled/absent.
 * @example
 * const isAccountingAvailable = useCompanyFeatureAvailable(companyFeaturesConstants.ACCOUNTING_MODULE);
 */
export const useCompanyFeatureAvailable = (featureName) => {
  const isLoaded = useSelector(state => state.company?.features?.loaded ?? false);
  const features = useSelector(state => state.company?.features?.data ?? EMPTY);

  if (!isLoaded) return false;

  const feature = features.find(f => f.feature === featureName);
  return feature?.value === true;
};
